import store from "@/store/index";
import Browser from "@/utils/browser";
import WebInstance from "./src/web";
import NativeInstance from "./src/native";
import NativeUtils from "@/utils/native/index";
import Loading from "@/packages/loading/index.js";
import { getRandomId, fullScreenInit } from "@/utils";
import { registerIframeCallback, initConfig } from "./src/common";

const qs = require("qs");
const browser = new Browser();
let platform = browser.getPlatform(); //获取当前平台-------> 1:iOS 2:Android 0:Web

class App {
    constructor() {}
        //初始化数据
    initData({
            identity,
            channel_id, //渠道id
            domain,    //域名
            return_url,   //返回跳转的地址
            server_type,  //游戏id
            style,   //多皮肤id
            return_type,  //返回类型为1则不显示返回按钮
            logo_type,    //是否自定义logo为1则自定义logo
            logo_url,   //自定义logo图片地址
            cate_id,    //大厅默认选中的分类id
            fullscreen_btn,   //是否显示壳的全屏按钮,为1则显示壳的全屏，默认不显示壳的全屏按钮
            is_app,    //是否是app访问
            switch_lang,   //是否显示切换多语言按钮，为1则显示
            extra, //md5标记
            lang    //默认语言类型，可选值：en/cn
        }) {
            let appInfo = {
                identity: identity,
                channel_id: channel_id,
                domain: domain,
                return_url: return_url,
                server_type: server_type,
                style: style,
                return_type: return_type,
                logo_type: logo_type,
                logo_url: logo_url, //自定义logoUrl
                cate_id: cate_id, //默认分类ID
                fullscreen_btn: fullscreen_btn, //是否显示壳的全屏按钮,为1则显示壳的全屏，默认不显示壳的全屏按钮
                is_app: is_app || 0,
                switch_lang:switch_lang || 1,  //是否显示切换语言的按钮，默认显示
                extra:extra,//md5标记
                lang:lang || 'cn'  //语言，默认中文
            };
            store.dispatch("setAppInfo", appInfo);
            const randomID = getRandomId(identity);
            store.dispatch("setRandomID", randomID);
        }
        //入口
    init() {
            registerIframeCallback();
            store.dispatch("setPlatform", platform);
            if (window.Storage && window.localStorage && window.localStorage instanceof Storage) {
                if (platform == 0) {
                    this.initWeb();
                } else {
                    this.initNativeApp();
                }
                window.__loading = Loading.service();
            }
            fullScreenInit(store.state.app.appInfo.fullscreen_btn, store.state.app.appInfo.is_app);
        }
        //初始化web应用
    initWeb() {
            let search = String(window.location.search);
            const param = search.substring(1, search.length);
            let initData = qs.parse(param);
            this.initData(initData);
            new WebInstance().init();
            //初始化配置
            initConfig();
        }
        //初始化原生APP应用
    initNativeApp() {
        //platform 1:iOS 2:Android 0:Web
        //注册声明native相关方法和事件
        window.nativeUtils = new NativeUtils(platform);
        //开始走原生的逻辑
        new NativeInstance().init();
    }
}

export default App;